export const FILTER_TYPES = {
    MARKET: "Market",
    SPORT: "Sport",
    TOURNAMENT: "Tournament" ,
    MATCH: "Match",
}
